<ng-template [ngComponentOutlet]="dynamicComponent | async" [ngComponentOutletInjector]="dInjector"></ng-template>
